import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <section
      className="pad-x"
      style={{
        padding: '120px 40px',
        maxWidth: 560,
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
      }}
    >
      <div
        style={{
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: '0.14em',
          color: 'var(--tag)',
          textTransform: 'uppercase',
        }}
      >
        404
      </div>
      <h1
        style={{
          fontSize: 40,
          fontWeight: 700,
          letterSpacing: '-0.03em',
          lineHeight: 1.1,
        }}
      >
        This page isn't going either.
      </h1>
      <p style={{ color: 'var(--fg-muted)', fontSize: 15, lineHeight: 1.65 }}>
        Something came up. It can't explain it yet but it will be able to by Monday.
      </p>
      <Link
        to="/"
        style={{
          padding: '12px 24px',
          background: 'var(--accent)',
          borderRadius: 6,
          color: '#0f0f0f',
          fontSize: 14,
          fontWeight: 600,
          textDecoration: 'none',
          alignSelf: 'flex-start',
        }}
      >
        Back home →
      </Link>
    </section>
  );
}
